import { EducationFilterRestrictModel } from "core/components/filter/components/educationFilter";
import { PlaceFilterRestrictModel } from "core/components/filter/components/placeFilter";
import { ForloebOverviewFilterModel } from "core/components/forloebOverview/ForloebOverviewFilterModel";
import PlaceAndEducationCrudFilterRestrictReponseModel from "services/api/stamdataRestrict/reponseModels/forloebCrudFilterRestrictReponseModel";
import PlaceAndEducationCrudFilterRestrictRequestModel from "services/api/stamdataRestrict/requestModels/placeAndEducationCrudFilterRestrictRequestModel";
import { BrugerListFilter } from "pages/bruger/brugerListFilter";
import EducationFilter, { EducationFilterResult } from "core/components/filter/components/educationFilter";
import PlaceFilter, { PlaceFilterResult } from "core/components/filter/components/placeFilter";

type PlaceAndEducationCrudFilterRestrictModel = Partial<& PlaceFilterRestrictModel & EducationFilterRestrictModel>;

const ToRequestModelFromForloebOverviewFilterModel = (filterModel: ForloebOverviewFilterModel) : PlaceAndEducationCrudFilterRestrictRequestModel => {
    return {
        specialer: filterModel.specialer ?? [],
        uddannelser: filterModel.uddannelser ?? [],
        regioner: filterModel.regioner ?? [],
        omraader: filterModel.omraader ?? [],
        afdelinger: filterModel.afdelinger ?? [],
        praksiser: filterModel.praksis ?? [],
        sygehuse: filterModel.hospitaler ?? [],
    }
};

const ToRequestModelFromBrugerListeFilterModel = (filterModel: BrugerListFilter) : PlaceAndEducationCrudFilterRestrictRequestModel => {
    return {
        specialer: filterModel.specialeIds ?? [],
        uddannelser: filterModel.uddannelseIds ?? [],
        regioner: filterModel.regionIds ?? [],
        omraader: filterModel.omraadeIds ?? [],
        afdelinger: filterModel.afdelingIds ?? [],
        praksiser: filterModel.praksisIds ?? [],
        sygehuse: filterModel.sygehusIds ?? [],
    }
} 

 const ToRequestModelFromFileFilterModel = (educationModel: EducationFilterResult, placeModel: PlaceFilterResult) : PlaceAndEducationCrudFilterRestrictRequestModel => {
    return {
        specialer: educationModel.specialer ?? [],
        uddannelser: educationModel.uddannelser ?? [],
        regioner: placeModel.regioner ?? [],
        omraader: placeModel.omraader ?? [],
        afdelinger: placeModel.afdelinger ?? [],
        praksiser: placeModel.praksiser ?? [],
        sygehuse: placeModel.sygehuse ?? [],
    }
} 

const PlaceAndEducationCrudFilterRestrictModelFromResponseModel = (reponseModel: PlaceAndEducationCrudFilterRestrictReponseModel) : PlaceAndEducationCrudFilterRestrictModel => reponseModel;

export default PlaceAndEducationCrudFilterRestrictModel;

export {
    PlaceAndEducationCrudFilterRestrictModelFromResponseModel,
    ToRequestModelFromForloebOverviewFilterModel,
    ToRequestModelFromBrugerListeFilterModel,
    ToRequestModelFromFileFilterModel
}